var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s_2"},[_c('el-input',{attrs:{"id":"input","placeholder":_vm.placeholder,"clearable":""},model:{value:(_vm.params.phone),callback:function ($$v) {_vm.$set(_vm.params, "phone", $$v)},expression:"params.phone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }